module.exports = __webpack_public_path__ + "static/media/SingleLegSquatMale.79c66a95.svg";